export interface BioSeal {
  bioSealFormat: string;
  biometrics: string;
  personalContent: any;
  documentContent: any;
  practitionerContent: any;
  testContent: any;
  eventContent: any;
}

export class BioSealStateModel {
  biosealState: BioSeal;
  isPersonalFormSubmitted: boolean;
  isDocumentFormSubmitted: boolean;
  isPractitionerFormSubmitted: boolean;
  isTestFormSubmitted: boolean;
  isEventFormSubmitted: boolean;
  isPersonalDataLoaded: boolean;
  isDocumentDataLoaded: boolean;
  isPractitionerDataLoaded: boolean;
  isTestDataLoaded: boolean;
  isEventDataLoaded: boolean;
  bioseal: any;
  qrCode: any;
  datamatrix: any;
  biosealLoaded: boolean;
  biosealLoading: boolean;
  biosealError: boolean;
  timeOut: boolean;
}
